import React from 'react'
import { Formik } from 'formik'
import { pick } from 'lodash'
import { UseMutateCandidateByIdReturn, candidateResumeReviewByIdDocument, useMutateCandidateById, useCandidateResumeReviewById, useHiringManagers, useCandidateRanks } from 'src/queries'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { MutateCandidateByIdMutation } from 'src/gql/graphql'
import Form from './Form'
import { emptyStringToNull } from 'src/helpers/formHelpers'

type Values = Parameters<UseMutateCandidateByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: string
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const candidate = useCandidateResumeReviewById(id)
  if (candidate === undefined) {
    throw new Error('Could not load candidate!')
  }
  const update = useMutateCandidateById()
  const initialState: Values = pick(candidate, [
    'resume.sent',
    'resume.reviewed',
    'resume.reviewed_by',
    'rank'
  ])
  const hiringManagers = useHiringManagers()
  const ranks = useCandidateRanks()
  const lookups = {
    hiringManagers,
    ranks
  }
  const invalidateCandidate = useInvalidateQueryByDocument(candidateResumeReviewByIdDocument)
  const handleSuccess = (data: MutateCandidateByIdMutation): void => {
    const id = data.cat?.candidate?.updateById?.recordId
    if (typeof id === 'string') {
      void invalidateCandidate({ id })
    }
    toggle()
  }
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        emptyStringToNull(record, 'resume.reviewed_by')
        emptyStringToNull(record, 'rank')
        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
    >
      {(props) => (
        <Form toggle={toggle} isLoading={update.isLoading} hasError={update.isError} lookups={lookups} />
      )}
    </Formik>
  )
}

export default FormContext
